import React from 'react';

import Translation from './Translation';

export const TranslationContext = React.createContext(
  new Translation()
);
